var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import styled from "styled-components";
import { useMsal } from "@azure/msal-react";
//import { IOpsCenterProps } from "../../../../components/Layout/Layout";
import { ClientRegistrationAPIService } from "../../util/ClientRegistrationAPI/ClientRegistrationAPI";
import { AutorizationService } from "../../util/AutorizationService/AutorizationService";
import { MegaMenuAPIService } from "../../util/MegaMenuAPIService/MegaMenuAPIService";
import jwt_decode from "jwt-decode";
import { loginRequest } from "../../../../Auth/authConfig";
import { useNavigate } from "react-router";
import { useAppContext } from "../../../../Context/AppContext";
const LoginWrapperContainer = styled.div.withConfig({ displayName: "LoginWrapperContainer", componentId: "-19ipgqw" }) `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 38rem;
  height: 100%;
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.1);
`;
const Logo = styled.img.withConfig({ displayName: "Logo", componentId: "-16hn98v" }) ``;
const LogoTextContainer = styled.div.withConfig({ displayName: "LogoTextContainer", componentId: "-1kwiwkc" }) `
  display: flex;
  flex-direction: column;
  width: 380px;
  padding: 1.5rem;
  border-radius: var(--border-radius, 4px);
  background: white;
`;
const RegisterContainer = styled.div.withConfig({ displayName: "RegisterContainer", componentId: "-117mlz7" }) `
  width: 100%;
  margin: 4% 32% 4% 32%;
`;
const LoginContainer = styled.div.withConfig({ displayName: "LoginContainer", componentId: "-vbv7st" }) `
  justify-content: space-between;
  align-items: center;
  width: 380px;
  padding: 1.5rem;
  border-radius: var(--border-radius, 4px);

  background: white;
`;
const SignUpContainer = styled.div.withConfig({ displayName: "SignUpContainer", componentId: "-16rbzhw" }) `
  display: flex;
  justify-content: space-between;
  align-items: self-start;
`;
const AlreadyUserButton = styled.button.withConfig({ displayName: "AlreadyUserButton", componentId: "-1qtxs0q" }) `
  font-size: 0.9rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  text-decoration: underline;
  margin-inline: 0;
`;
const SignUpHeading = styled.div.withConfig({ displayName: "SignUpHeading", componentId: "-2yf7lk" }) `
  font-size: 2rem;
  line-height: 1.6rem;
  font-weight: 600;
  margin-bottom: 3rem;
`;
const RegionLabel = styled.label.withConfig({ displayName: "RegionLabel", componentId: "-34d52x" }) `
  font-weight: 500;
  margin-bottom: 20px;
`;
const RegionSelect = styled.select.withConfig({ displayName: "RegionSelect", componentId: "-uqxil8" }) ``;
const RegisterButton = styled.button.withConfig({ displayName: "RegisterButton", componentId: "-1axxidx" }) `
  && {
    display: flex;
    padding: 0.5rem 1rem;
    align-items: flex-end;
    gap: 0.625rem;
    border-radius: 0.25rem;
    background: #512da8;
    margin-left: auto;
    margin-top: 1.5rem;
  }
`;
const ConsentContainer = styled.div.withConfig({ displayName: "ConsentContainer", componentId: "-1u8gw2d" }) `
  display: flex;
  align-items: flex-start;
  margin-top: 1rem;
`;
const ConsentText = styled.div.withConfig({ displayName: "ConsentText", componentId: "-orogw4" }) `
  font-size: 0.8rem;
`;
const ConsentLink = styled.a.withConfig({ displayName: "ConsentLink", componentId: "-chl74j" }) `
  color: #0a0a0a;
  text-decoration: underline;
  margin-right: 0.5rem;

  &:hover {
    text-decoration: none;
  }
`;
const ConsentCheckbox = styled.input.withConfig({ displayName: "ConsentCheckbox", componentId: "-xu4mal" }) `
  &&& {
    margin: 6px 0.5rem 0 0;
  }
`;
const ConsentMessage = styled.div.withConfig({ displayName: "ConsentMessage", componentId: "-cwoefc" }) `
  color: red;
  margin-top: 0.5rem;
`;
const CopyrightText = styled.p.withConfig({ displayName: "CopyrightText", componentId: "-1vg3edj" }) `
  margin-top: 1rem;
  font-size: 0.8rem;
  text-align: center;
`;
const PolicyLink = styled.a.withConfig({ displayName: "PolicyLink", componentId: "-1c6kwwz" }) `
  color: #0a0a0a;
  text-decoration: underline;
  font-weight: 500;
  &:hover {
    text-decoration: none;
  }
`;
const MenuHeaderTextContainer = styled.div.withConfig({ displayName: "MenuHeaderTextContainer", componentId: "-sq0slb" }) `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`;
const MenuHeaderTextTitle = styled.span.withConfig({ displayName: "MenuHeaderTextTitle", componentId: "-1uns29e" }) `
  color: #0f0e0e;
  font-size: 2em;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
const MenuHeaderTextVersion = styled.span.withConfig({ displayName: "MenuHeaderTextVersion", componentId: "-1d2vjb6" }) `
  color: #707070;
  font-size: 1.25em;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
const initialLoginState = {
    preferredRegion: "default",
    consentChecked: false,
    showConsentMessage: false,
};
export const Register = () => {
    const [loginState, setLoginState] = useState(initialLoginState);
    const { appState, setAppState } = useAppContext();
    const navigate = useNavigate();
    const { instance } = useMsal();
    const checkUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
            const response = yield instance.acquireTokenSilent(Object.assign(Object.assign({}, loginRequest), { account: accounts[0] }));
            const decodedToken = jwt_decode(response.accessToken);
            const user = {
                tenantId: decodedToken.tid,
                name: decodedToken.given_name,
                userName: decodedToken.upn,
                tenantURL: sessionStorage.getItem("TenantURL"),
            };
            console.log(user, "user");
            return user;
        }
    });
    const sendClientRegistration = (user) => __awaiter(void 0, void 0, void 0, function* () {
        const isAdmin = yield AutorizationService.IsAdmin();
        const registration = {
            tenantId: user.tenantId,
            region: loginState.preferredRegion,
            host: user.tenantURL || "",
            createdBy: user.userName,
            modifiedBy: user.userName,
            realm: "",
        };
        const clientRegistrationRequest = yield ClientRegistrationAPIService.postClientRegistration(registration);
        if (clientRegistrationRequest) {
            handleUserRegistered(user, isAdmin);
        }
    });
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        //props.setLoading(true);
        const { consentChecked, preferredRegion } = loginState;
        if (!consentChecked) {
            setLoginState((prevState) => (Object.assign(Object.assign({}, prevState), { showConsentMessage: true })));
            //props.setLoading(false);
            return;
        }
        setLoginState((prevState) => (Object.assign(Object.assign({}, prevState), { preferredRegion })));
        try {
            const user = yield checkUser();
            sendClientRegistration(user);
        }
        catch (error) {
            setAppState((prevState) => (Object.assign(Object.assign({}, prevState), { hasError: true, isLoading: false })));
        }
        finally {
            setAppState((prevState) => (Object.assign(Object.assign({}, prevState), { isClientRegistered: true })));
        }
    });
    const handleUserRegistered = (user, isAdmin) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const checkRegionResponse = yield ClientRegistrationAPIService.getClientRegistration(user.tenantId);
            if (checkRegionResponse.createdBy == checkRegionResponse.modifiedBy &&
                !isAdmin) {
                yield assignAdminRoles(user.userName);
            }
            if (checkRegionResponse.tenantId === user.tenantId) {
                sessionStorage.setItem("Region", loginState.preferredRegion);
            }
            navigate("/");
        }
        catch (error) {
            setAppState((prevState) => (Object.assign(Object.assign({}, prevState), { hasError: true })));
        }
    });
    const assignAdminRoles = (userName) => __awaiter(void 0, void 0, void 0, function* () {
        yield MegaMenuAPIService.addAssignedUsers(userName, "admins");
        appState.isLoading = false;
    });
    const handleConsentChange = (e) => {
        const { checked } = e.target;
        setLoginState((prevState) => (Object.assign(Object.assign({}, prevState), { consentChecked: checked, showConsentMessage: false })));
    };
    return (_jsx(RegisterContainer, { children: _jsx(_Fragment, { children: _jsxs(LoginWrapperContainer, { children: [_jsxs(LogoTextContainer, { children: [_jsx("img", { src: "/lvt_logo.svg", alt: "logo", height: "50px", width: "56px" }), _jsxs(MenuHeaderTextContainer, { children: [_jsx(MenuHeaderTextTitle, { children: "Operations Center" }), _jsx(MenuHeaderTextVersion, { children: "Version 1.1.1" })] })] }), _jsxs(LoginContainer, { children: [_jsx(SignUpContainer, {}), _jsx(RegionLabel, { children: "It seems it's your first access " }), _jsxs(RegionSelect, Object.assign({ value: loginState.preferredRegion, onChange: (e) => setLoginState((prevState) => (Object.assign(Object.assign({}, prevState), { preferredRegion: e.target.value }))), className: "lt-style" }, { children: [_jsx("option", Object.assign({ disabled: true, value: "default" }, { children: "Select your region" })), _jsx("option", Object.assign({ value: "EMEA" }, { children: "Europe" }))] })), _jsx(RegisterButton, Object.assign({ type: "button", onClick: handleSubmit, className: "lt-style" }, { children: "Continue" })), _jsxs(ConsentContainer, { children: [_jsx(ConsentCheckbox, { type: "checkbox", checked: loginState.consentChecked, onChange: handleConsentChange, className: "lt-style" }), _jsxs(ConsentText, { children: ["I agree to the LiveTiles\u00A0", _jsx(ConsentLink, Object.assign({ href: "/General Data Protection Regulation End User License Agreement" }, { children: "General Data Protection Regulation End User License Agreement," })), _jsx(ConsentLink, Object.assign({ href: "https://livetilesglobal.com/livetiles-privacy-policy/" }, { children: "Privacy Policy," })), _jsx(ConsentLink, Object.assign({ href: "https://livetilesglobal.com/terms-and-conditions/" }, { children: "Terms and Conditions," })), _jsx(ConsentLink, Object.assign({ href: "https://livetilesglobal.com/eula/" }, { children: "End User License Agreement" })), "and\u00A0", _jsx(ConsentLink, Object.assign({ href: "https://livetilesglobal.com/wp-content/uploads/2022/01/LiveTiles_Data_Processing_Agreement_DPA.pdf" }, { children: "Data Processing Agreement" }))] })] }), loginState.showConsentMessage && (_jsx(ConsentMessage, { children: "Please agree to the consent before registering." }))] }), _jsxs(CopyrightText, { children: ["Copyright \u00A9 ", new Date().getFullYear(), " LiveTiles. All rights reserved"] }), _jsx(PolicyLink, Object.assign({ href: "https://livetilesglobal.com/livetiles-privacy-policy/" }, { children: "Privacy Policy" }))] }) }) }));
};
